<template>
	<div class="role">
		<div class="right-wrap">
			<el-button @click="showDialog('add')" class="add qjc-fts-16">添加商品</el-button>
			
			<el-table
				:data="list"
				style="width: 100%"
				:header-cell-style="{background:'#f0f3f8',color:'#333'}"
			>
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
						<div class="empty-text">暫無數據</div>
					</div>
				</template>
				<el-table-column
					label="編號"
					prop="id"
					width="80"
				></el-table-column>
				<el-table-column
					label="商品名稱"
					prop="name"
				></el-table-column>
				<!-- <el-table-column
					label="市場價格"
					prop="cost_price"
				></el-table-column>
				<el-table-column
					label="價格"
					prop="price"
				></el-table-column>
				<el-table-column
					label="驗血價格"
					prop="blood_price"
				></el-table-column> -->
				<el-table-column
					label="商品代碼"
					prop="type"
				>
					<template slot-scope="scope">
						{{scope.row.type ? scope.row.type : "--"}}
					</template>
				</el-table-column>
				
				<el-table-column
					label="狀態"
					prop="status"
				>
					<template slot-scope="scope">
						<el-switch
							@change="handleStatus(scope.row)"
							v-model="scope.row.status"
							active-value="1"
							inactive-value="0"
							active-color="#38E019"
							inactive-color="#FF5219">
						</el-switch>
						<!-- <div class="">{{scope.row.status == 1 ? '启用' : '禁用'}}</div> -->
					</template>
				</el-table-column>
				<el-table-column
					label="操作日期"
					prop="updated_at"
				>
					<template slot-scope="scope">
						<div class="">{{scope.row.updated_at ? scope.row.updated_at : '--'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					prop="action"
				>
					<template slot-scope="scope">
						<div class=""><i class="el-icon-edit" @click="showDialog('update',scope.row.id)"></i></div>
					</template>
				</el-table-column>
				
			</el-table>
			
			<!-- 分页 -->
			<el-pagination
				prev-text="上一頁"
				next-text="下一頁"
				@current-change="pageChange"
				class="pagination qjc-texta-c"
				:current-page.sync="pager.page"
				hide-on-single-page
				:page-size="pager.pagesize"
				layout="total, prev, pager, next,jumper"
				:total="pager.count">
			</el-pagination>
			
			
			<!-- 添加、修改弹窗 -->
			<el-dialog
			  :title="(oper == 'add'?'添加':(oper == 'edit'?'修改':'')) + '商品'"
			  :visible.sync="isAlert"
			  width="50%" >
				<el-form
					:model="formData"
					:rules="rules"
					ref="form"
				>
					<el-form-item
						label="商品名稱"
						prop="name"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.name"
								placeholder="請輸入"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item
						label="價格"
						prop="price"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.price"
								placeholder="請輸入"
								type="number"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item
						label="市場價格"
						prop="cost_price"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.cost_price"
								type="number"
								placeholder="請輸入"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item
						label="驗血價格"
						prop="blood_price"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.blood_price"
								type="number"
								placeholder="請輸入"
							></el-input>
						</div>
					</el-form-item>
					<div class="custom_wrap" v-if="custom && custom.base">
						<div class="custom_item">
							<div class="custom_item_title">基础体检套餐</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" v-model="base.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number" v-model="base.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}" ></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-通用健康评分</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="mlev.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number" v-model="mlev.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-同族群PLM对比</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="packageA.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number"  v-model="packageA.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-共病风险</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="packageB.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number"  v-model="packageB.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-疾病风险远期预测</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="packageC.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number" v-model="packageC.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}" ></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-健康促进方案</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="packageD.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">价格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number" v-model="packageD.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
								</div>
							</div>
						</div>
						<div class="custom_item">
							<div class="custom_item_title">增值包-骨折风险评估</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">名称</div>
								<div class="custom_item_val">
									<el-input class="" v-model="packageFB.name"></el-input>
								</div>
							</div>
							<div class="custom_item_cell">
								<div class="custom_item_label">價格</div>
								<div class="custom_item_val">
									<el-input class="custom_item_input" type="number" v-model="packageFB.price" onkeyup="if(value===''){value=0};value=value.replace(/[^0-9.]/g,'');if(value>=99){value=99};if(String(value)==='0'){value=0}"></el-input>
								</div>
							</div>
						</div>
					</div>
					
					<el-form-item
						label="商品代碼"
						prop="type"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.type"
								type="text"
								placeholder="請輸入"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item
						label="排序"
						prop="sort"
					>
						<div class="code_cell">
							<el-input
								v-model="formData.sort"
								type="number"
								placeholder="請輸入"
							></el-input>
						</div>
					</el-form-item>
					<el-form-item
						label="狀態"
						prop="status"
					>
						<el-switch
						  v-model="formData.status"
						  active-color="#38E019"
						  inactive-color="#FF5219">
						</el-switch>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button class="cancel-btn" @click="formCancel">取消</el-button>
					<el-button class="submit-btn" @click="formSubmit">提交</el-button>
				</span>
			</el-dialog>
			
		</div>
	</div>
</template>

<script>
	import goods from '../assets/js/goods'
	
	import Alert from '../components/alert'
	export default {
	    components:{
	        Alert
	    },
	    name: "goods",
	    ...goods
	}
</script>

<style scoped>
	.stepTit {
		/* margin-bottom: 0.2rem; */
		text-align: left;
		font-size: 0.16rem;
		font-family: PingFangTC-Medium,PingFangTC;
		font-weight: 500;
		color: rgba(64,68,77,1);
		line-height: 0.16rem;
	}
	.el-dialog .el-form .el-form-item >>>  .code_cell .el-input__inner {
		padding-right: 80px !important;
	}
	.el-dialog .el-form .el-form-item >>> .el-date-editor.el-input, .el-dialog .el-form .el-form-item >>> .el-date-editor.el-input__inner {
		width: 100%;
	}
	.el-dialog .el-form .el-form-item >>> .el-select {
		width: 100%;
	}
	.el-dialog .el-form >>> .el-form-item {
		margin-bottom: 8px;
	}
	.el-dialog .el-form >>> .el-form-item__label{
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}
	.el-dialog .el-form >>> .el-form-item__content{
		float: left;
		width: 60%;
		margin-right: 0;
	}
	.right-wrap >>> .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
	}
	.right-wrap >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
	}
	.right-wrap >>> .el-switch__core:after {
		/* background-color: #828DBC; */
	}
	.right-wrap >>> .el-switch.is-checked .el-switch__core::after {
		/* background-color: #6681FA;	 */
	}
	.right-wrap >>> .el-input-number__increase {
		display: none;
	}
	.right-wrap >>> .el-input-number__decrease {
		display: none;
	}
	.right-wrap .input-number >>> .el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}
	
	::v-deep input::-webkit-outer-spin-button,::v-deep input::-webkit-inner-spin-button{
	  -webkit-appearance: none !important;
	}
	::v-deep input[type='number']{
	  line-height: 1;
	  -moz-appearance: textfield !important;
	}
	
</style>
<style lang="scss" scoped>
	.role{
		// display: flex;
		width: 100%;
		height: 100%;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				line-height: 20px;
				cursor: pointer;
			}
			.left-enp-item-active {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				line-height: 20px;
			}
		}
		
		.right-wrap {
			flex: 1;
			padding: 10px 20px;
			height: 100%;
			overflow: auto;
			background-color: #fff;
			
			.right-temp {
				margin-bottom: 32px;
				
				.temp-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #293033;
					line-height: 24px;
					padding-bottom: 10px;
					border-bottom: 1px solid #E5E8F5;
				}
				
				.temp-info {
					margin-top: 12px;
				}
			}
			
			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 34px;
				background-color: #6883FB;
				border-radius: 17px;
				border: none;
				// margin-top: 10px;
			}
			.info-cell {
				margin-bottom: 20px;
			}
			.input-number {
				width: 50px;
			}
			.custom-info {
				position: relative;
				width: 670px;
				padding: 24px;
				border: 1px solid #CED4F0;
				border-radius: 4px;
				margin-top: 10px;
				
				&::before {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -16px;
					left: 41px;
					padding: 0;
					border-top: 8px solid transparent;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-bottom: 8px solid #fff;
					display: block;
					content: '';
					z-index: 12;
				}
				
				&::after {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -18px;
					left: 40px;
					padding: 0;
					border-top: 9px solid transparent;
					border-left: 9px solid transparent;
					border-right: 9px solid transparent;
					border-bottom: 9px solid #CED4F0;
					display: block;
					content: '';
					z-index: 10;
				}
			}
			.custom-group {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				
				.custom-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 30%;
					margin-right: 20px;
				}
			}
		}
		
		.add{
			padding: 8px 12px;
			margin: 12px 0 12px;
			color: #fff;
		}
		
		.el-table{
			i[class^=el-icon]{
				margin-right: 16px;
				cursor: pointer;
			}
		}
		
		.el-pagination{
			text-align: center;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					// padding: 9px 15px;
				}
			}
		}
	}
	
	.quota_cell {
		position: relative;
		display: flex;
		align-items: center;
		
		.unit {
			position: absolute;
			right: 10px;
			top: 0px;
		}
	}
	.times_cell {
		display: flex;
		align-items: center;
		
		.noTimes {
			height: 40px;
			padding: 0 12px;
			margin-left: 10px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
		}
		.active {
			border: 1px solid #6681FA;
		}
	}
	.empty-wrap {
		padding: 100px 0;
	}
	.empty-img {
		width: 338px;
		height: 218px;
	}
	
	
	.el-icon-edit {
		color: #6681FA;
	}
	
	
	.custom_title {
		font-size: 15px;
		margin: 20px 0;
		padding-left: 120px;
	}
	.custom_wrap {
		display: flex;
		align-items: center;
		// justify-content: space-between;
		flex-wrap: wrap;
		flex-direction: row;
		padding: 0 52px;
		margin-bottom: 20px;
		
		.custom_item {
			width: 46%;
			margin-bottom: 10px;
			
			&:nth-child(2n) {
				width: 42%;
				position: relative;
				left: -34px;
			}
			
			.custom_item_title {
				font-size: 15px;
				padding-left: 100px;
				margin-bottom: 10px;
				margin-top: 10px;
			}
		}
	}
	.custom_item_cell {
		display: flex;
		align-items: center;
		// justify-content: center;
		width: 100%;
		margin-bottom: 8px;
		
		.custom_item_label {
			width: 28%;
			padding: 0 12px 0 0;
			padding-right: 24px;
			margin-left: 4%;
			text-align: right;
			font-size: 14px;
			color: #606266;
			line-height: 40px;
		}
		
		.custom_item_val {
			width: 60%;
		}
	}
	
	.pagination{
		padding-right: 24px;
		text-align: center;
		margin-top: 6px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
	}
	
	
</style>
